import script from "./DrugIndicationCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DrugIndicationCard.vue?vue&type=script&setup=true&lang=js"

import "./DrugIndicationCard.vue?vue&type=style&index=0&id=229306fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-229306fe"]])

export default __exports__